module.exports = "https://cdn.realtymogul.com/static/media/icon_wallet.ae9e374e.svg";